import createService from '@/utils/requestBase'
// import configs from '@/config'
export default createService({ baseURL: process.env.VUE_APP_BASE_API })
// iotcenter
